var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MdIco fl0",class:_vm.icnClass},[_c('div',[_c('span',{style:(_vm.icnStyle)})])])}
var staticRenderFns = []

export { render, staticRenderFns }